import React, { forwardRef, useContext } from 'react';
import DiscoveryContextV2 from '../../../contexts/discoveryContext/contextV2';

const WithLocationInfo = (ChildComponent) =>
  forwardRef(({ injected, ...props }, ref) => {
    const {
      pushHistory,
      operations: { setLocation },
      filters: {
        location: { viewport, point, name, isLocationSetByUser },
      },
    } = useContext(DiscoveryContextV2);

    return (
      <ChildComponent
        injected={{
          ...injected,
          location: {
            name,
            point,
            viewport,
            isLocationSetByUser,
            setPoint: (propName, propPoint, historyObj = {}) => {
              setLocation({ type: 'Point', point: propPoint, name: propName });

              delete historyObj.background;
              pushHistory(historyObj);
            },
            setViewport: (propName, propViewport, historyObj = {}) => {
              setLocation({
                type: 'Viewport',
                viewport: propViewport,
                name: propName,
              });

              delete historyObj.background;
              pushHistory(historyObj);
            },
          },
        }}
        ref={ref}
        {...props}
      />
    );
  });

export default WithLocationInfo;
